import React from 'react'
import { Link } from 'react-router-dom'
import styles from './unavailable.module.css'
import shopClosed from '../../../assets/store-close.svg'

const ShopUnavailable = () => {
  return (
    <div data-testid="shopUnavailableFC" className={styles.container}>
      <img src={shopClosed} width="160" alt="Store closed" />
      <h2 className={styles.text}>Sorry, shop is currently unavailble.</h2>
      <Link to="/">
        <button className="mochi-button">&laquo; Back to homepage</button>
      </Link>
    </div>
  )
}

export default ShopUnavailable
